import http from '@/utils/http';
const rootUrl = '/api';

const Login = {
	/**
	 * 获取联系方式
	 * @returns
	 */
	getOiga( lang, oemUrl ) {
		return http.get( `${rootUrl}/getOEMAreaInfoV2?oemURL=${oemUrl}&lang=${lang}&origin=sdkCloud`, { errCode: 'login.getOiga' });
	},
	/**
	 * 获取首页banner
	 */
	getOig( oemUrl ) {
		return http.get( `${rootUrl}/getOEMInfoV2?oemURL=${oemUrl}`, { errCode: 'login.getOig' });
	},
	/**
	 * 获取隐私政策
	 */
	getOigpc( lang, oemUrl, type, source = 'sdkCloud' ) {
		return http.get( `${rootUrl}/getOEMPrivacyColorInfoByTypeV2?oemURL=${oemUrl}&lang=${lang}&privacyType=${type}&origin=${source}`, { errCode: 'login.getOigpc' });
	},
	/**
	 * 完善信息接口
	 * @param {*} params
	 * @returns
	 */
	accountImprove( data ) {
		return http.post( `${rootUrl}/improveAccountv2`, {
			data,
			errCode: 'login.accountImprove',
		}, { headers: { isCsrf: true } });
	},
	/**
	 * 获取机构列表
	 */
	getFactoryBriefList( params ) {
		return http.get( `${rootUrl}/dentalMemberAffiliatedOrgs`, { params });
	},
	getFactoryListByUser( params ) {
		return http.get( `${rootUrl}/userFactorList`, { params });
	},
};
export default Login;
